import styles from "./EnderecoItem.module.scss";
import { IEnderecoUser } from "shared/interfaces/IEnderecoUser";
import {
  EllipsisVertical, Star, Trash2, Pencil
} from "lucide-react";
import { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

interface Props {
  endereco: IEnderecoUser;
  onExcluir: (id: string) => void;
  onDefinirPrincipal: (id: string) => void;
  onSelect?: (endereco: IEnderecoUser) => void;
}

export const EnderecoItem: React.FC<Props> = ({endereco,onExcluir,onDefinirPrincipal,onSelect}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!menuRef.current) return;

      if (!menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);


  const handleExcluir = () => {
    onExcluir(endereco.id);
    setMenuOpen(false);
  };

  const handlePrincipal = () => {
    onDefinirPrincipal(endereco.id);
    setMenuOpen(false);
  };

  const handleEditar = () => {
  navigate(`/editarendereco/${endereco.id}`, {
    state: location.state,
  });

  setMenuOpen(false);
};

  return (
    <div className={styles.page}>
      <div className={`${styles.containerEnd} ${ endereco.enderecoPrincipal ? 
      styles.principal : styles.secundario }`} onClick={() => onSelect?.(endereco)}>
        <div className={styles.containerHeader}>
          <div className={styles.nomeWrapper}>
            <strong>{endereco.nome}</strong>

            {endereco.enderecoPrincipal && (
              <span className={styles.badgePrincipal}>
                <Star size={12} fill="white" /> Principal
              </span>
            )}
          </div>

          <div className={styles.menuWrapper} ref={menuRef}>
            <EllipsisVertical
              size={18}
              className={styles.iconMenu}
              onClick={(e) => {
                e.stopPropagation();
                setMenuOpen((prev) => !prev);
              }}
            />

            {menuOpen && (
              <div className={styles.popupMenu}>
                {!endereco.enderecoPrincipal && (
                  <button  onClick={(e) => {e.stopPropagation();handlePrincipal();}}>
                    <Star size={14} /> Tornar principal
                  </button>
                )}

                <button onClick={(e) => {e.stopPropagation();handleEditar();}}>
                  <Pencil size={14} /> Editar
                </button>

                <button className={styles.delete} onClick={(e) => { e.stopPropagation();
                        handleExcluir(); }}>
                  <Trash2 size={14} /> Excluir
                </button>
              </div>
            )}
          </div>
        </div>

        <div className={styles.enderecoInfo}>
          <p>{endereco.rua}, {endereco.numero}</p>
          <p>
            - {endereco.bairro} - {endereco.cidade} - {endereco.estado}
          </p>
        </div>

        {endereco.complemento && <p>{endereco.complemento}</p>}
        <p>CEP: {endereco.cep}</p>
      </div>
    </div>
  );
};